<template>
  <data-table-row class="ai-visibility-question-row">
    <data-table-cell width="42%">
      <span class="ai-visibility-question-row__question" :title="row.questionText">{{ row.questionText }}</span>
    </data-table-cell>
    <data-table-cell class="ai-visibility-question-row__status" width="22%">
      <status-pill
        :tone="statusPill.tone"
        :label="statusPill.label"
        dot
      />
    </data-table-cell>
    <data-table-cell width="14%" align="right" class="ai-visibility-question-row__position">
      <strong>{{ positionLabel }}</strong>
    </data-table-cell>
    <data-table-cell width="22%" align="right">
      <span
        class="ai-visibility-question-row__movement"
        :class="changeDirectionClass"
      >
        {{ changeLabel }}
        <i v-if="changeIcon" class="material-icons">{{ changeIcon }}</i>
      </span>
    </data-table-cell>
  </data-table-row>
</template>

<script>
import StatusPill from '../../../ui/display/StatusPill.vue'
import DataTableRow from '../../../ui/table/DataTableRow.vue'
import DataTableCell from '../../../ui/table/DataTableCell.vue'

const STATUS_PILLS = {
  mentioned: { tone: 'success', label: "You're in" },
  missing: { tone: 'danger', label: 'Missing' },
  new: { tone: 'info', label: 'New' },
}

export default {
  name: 'TrackedQuestionRow',
  components: {
    StatusPill,
    DataTableRow,
    DataTableCell,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusPill () {
      return STATUS_PILLS[this.row.status]
    },
    positionLabel () {
      return this.row.status === 'missing' ? '-' : `#${this.row.averagePosition}`
    },
    changeDirection () {
      if (this.row.change > 0) {
        return 'positive'
      }

      if (this.row.change < 0) {
        return 'negative'
      }

      return 'neutral'
    },
    changeDirectionClass () {
      return this.changeDirection === 'neutral'
        ? ''
        : `ai-visibility-question-row__movement--${this.changeDirection}`
    },
    changeLabel () {
      if (this.row.change > 0) {
        return `Up to +${this.row.change}`
      }

      if (this.row.change < 0) {
        return `Drop to ${this.row.change}`
      }

      return 'No change'
    },
    changeIcon () {
      return {
        positive: 'arrow_upward',
        negative: 'arrow_downward',
      }[this.changeDirection] || ''
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-question-row__question {
  display: block;
  overflow: hidden;
  color: var(--v-mainColor-base);
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
}

.ai-visibility-question-row__position > strong {
  color: var(--v-mainColor-base);
  font-size: 16px;
}

.ai-visibility-question-row__status ::v-deep .ai-visibility-status-pill {
  width: 100%;
}

.ai-visibility-question-row__movement {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  color: var(--v-gray60Color-base);
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.ai-visibility-question-row__movement i {
  font-size: 16px;
  line-height: 1;
}

.ai-visibility-question-row__movement--positive i {
  color: var(--v-green20Color-base);
}

.ai-visibility-question-row__movement--negative i {
  color: var(--v-red11Color-base);
}
</style>
